import {Banner} from '@primer/react'

const DEFINITIONS_LIMIT = 100
export function isDefinitionsLimitReached(definitionsCount: number, limit = DEFINITIONS_LIMIT) {
  return definitionsCount >= limit
}

interface Props {
  definitionsLimit?: number
}

export function DefinitionsLimitBanner({definitionsLimit = DEFINITIONS_LIMIT}: Props) {
  return (
    <Banner
      title="Definitions limit"
      hideTitle
      variant="info"
      data-testid="definitions-limit-banner"
      description={`The limit of ${definitionsLimit} definitions is reached. You cannot add more.`}
    />
  )
}

try{ DefinitionsLimitBanner.displayName ||= 'DefinitionsLimitBanner' } catch {}